import ProductCard from "../product-card/ProductCard";
import "./category-preview.styles.scss";
import { Link } from "react-router-dom";

const CategoryPreview = ({ title, products }) => {
  return (
    <div className="category-preview-container">
      <h2>
        <Link className="title" to={title}>
          {title.toUpperCase()}
        </Link>
      </h2>
      <div className="preview">
        {products
          .filter((_, idx) => idx < 4)
          .map((item) => {
            return <ProductCard key={item.id} products={item} />;
          })}
      </div>
    </div>
  );
};

export default CategoryPreview;
